<script lang="ts">
  import { getStr } from '../../../common/util';
  import Icon from './Icon.svelte';
  import Text from './Text.svelte';

  interface LabelPosition {
    code: 'TOP' | 'BOTTOM';
    type: string;
  }

  interface ConditionLabel {
    iconUrl?: string;
    label?: string;
    subTitle?: string;
    lableUrl?: string | null;
    displayOrder?: number;
    isWarranty?: boolean;
    labelPosition?: LabelPosition;
  }

  interface MarketplaceOffer {
    state?: string;
    conditionLabels?: ConditionLabel[];
    conditionCode?: string;
  }

  export let offer: MarketplaceOffer = {};

  console.log('offer', offer);

  function sortByDisplayOrder(labels: ConditionLabel[] = []) {
    return [...labels].sort(
      (a, b) => (a.displayOrder ?? Number.MAX_SAFE_INTEGER) - (b.displayOrder ?? Number.MAX_SAFE_INTEGER)
    );
  }

  const offerCondition = getStr(`extra.marketplace.condition.${offer?.conditionCode}`);
  function getLabelsByPosition(position: string) {
    return sortByDisplayOrder((offer?.conditionLabels ?? []).filter(item => item.labelPosition?.code === position));
  }

  let topLabels = getLabelsByPosition('TOP');
  let bottomLabels = getLabelsByPosition('BOTTOM');
</script>

<div class="mp_seller-condition-wrapper">
  <div class="card">
    <div class="header">
      <div class="header-icon {offer?.conditionCode === 'OPEN_BOX' ? 'open-box' : ''}">
        <Icon glyph="icon-verified" type="primary" mobileSize={18} desktopSize={24} />
      </div>

      <div class="header-text">
        <Text key="extra.marketplace.pdp.seller.certified.text" args={[offerCondition]} />

        {#if offer.state}
          <span class="divider"></span>

          <span class="condition-value"
            ><Text key="extra.marketplace.pdp.seller.condition.value.text" args={[offer?.state]} />
          </span>
        {/if}
      </div>
    </div>

    {#if topLabels.length}
      <div class="content">
        {#each topLabels as item, index (`${item.label}-${item.displayOrder}`)}
          <div class="info">
            <div class="icon">
              <img src={item.iconUrl} alt={item.label} />
            </div>

            <div class="info-text">
              <h3>{item.label}</h3>

              {#if item.subTitle}
                <p>{item.subTitle}</p>
              {/if}
            </div>
          </div>
          {#if index !== topLabels.length - 1}
            <hr />
          {/if}
        {/each}
      </div>
    {/if}

    {#if bottomLabels.length}
      <div class="footer">
        {#each bottomLabels as item, index (`${item.label}-${item.displayOrder}`)}
          <div class="badge">
            <div class="badge-icon">
              <img class="bottom-icon" src={item.iconUrl} alt={item.label} loading="lazy" />
            </div>

            <span>{item.label}</span>
          </div>

          {#if index !== bottomLabels.length - 1}
            <div class="separator"></div>
          {/if}
        {/each}
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .mp_seller-condition-wrapper {
    background-color: $neutral-light-04;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin-top: 8px;
    @include responsive {
      border-radius: 8px;
    }

    .card {
      background: $primary-white;
      border-radius: 8px;
      padding: 8px 8px 8px 10px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      @include responsive {
        gap: 8px;
      }
    }
    .header {
      display: flex;
      align-items: center;
      gap: 6px;
      .open-box {
        --color0: #591953;
        --color1: #ffffff;
        --color2: #e7d9e8;
      }
    }

    .header-text {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: $neutral-dark-01;
      .condition-value {
        font-weight: 500;
      }
      @include responsive {
        font-size: 14px;
        line-height: 16px;
      }
    }

    .divider {
      height: 16px;
      border: 1px solid $neutral-dark-01;
    }

    .content {
      width: fit-content;
      .info {
        display: flex;
        gap: 10px;
        align-items: center;
        .icon {
          img {
            width: 18px;
            height: 18px;
          }
        }

        .info-text {
          display: flex;
          flex-direction: column;
          gap: 2px;
          h3 {
            color: #035a8f;
            font-weight: 700;
            font-size: 13px;
            line-height: 150%;
            margin: 0;
            @include responsive {
              font-size: 11px;
            }
          }

          p {
            font-weight: 400;
            font-size: 12px;
            line-height: 150%;
            margin: 0;
            @include responsive {
              font-size: 11px;
            }
          }
        }
      }

      hr {
        border: none;
        border-top: 1px solid #f0f0f0;
        margin: 10px 0;
      }
    }

    .footer {
      background: linear-gradient(0deg, #047ac2, #047ac2), linear-gradient(90deg, #035a8f 0%, #047ac2 50%, #035a8f 100%);
      border: 0.4px solid #e5e7eb;
      border-radius: 16px;
      padding: 12px 35px;
      display: flex;
      align-items: center;
      gap: 28px;
      @include responsive {
        padding: 14px 8px 12px 18px;
        gap: 15px;
      }
    }

    .badge {
      flex: 1;
      color: $primary-white;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      .bottom-icon {
        width: 14px;
        height: 14px;
        @include responsive {
          width: 12px;
          height: 12px;
        }
      }
      span {
        font-size: 12px;
        line-height: 140%;
        font-weight: 400;
        @include responsive {
          font-size: 10px;
        }
      }
    }

    .separator {
      height: 18px;
      border: 0.5px solid #e1e1e1;
      @include responsive {
        height: 14px;
      }
    }
  }
</style>
